"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Forms/FormCard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _forms = require('shared/services/forms');
var _store = require('web/store');
var _ui = require('web/services/ui');
var _noticeBar = require('web/services/context/noticeBar');
var _FormStatusChip = require('./FormStatusChip'); var _FormStatusChip2 = _interopRequireDefault(_FormStatusChip);
var _sendFormRequests = require('./sendFormRequests');








/* A sent form in its chat (screen 18): the first page, form and child, the
 * status chip, and Copy link, Open and Send again. */
const FormCard = ({ code, conversationKey, card }) => {
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  const familyLink = _optionalChain([card, 'optionalAccess', _ => _.FamilyLink])
  const formKey = _optionalChain([card, 'optionalAccess', _2 => _2.FormKey])
  // The family's link, on purpose: staff paste it where the family reads it.
  const copyLink = _react.useCallback.call(void 0, () => {
    if (!familyLink) return
    _ui.copyToClipboard.call(void 0, familyLink)
      .then(() => showSuccessBar('Link copied'))
      .catch(() => showWarningBar("Couldn't copy the link"))
  }, [familyLink, showSuccessBar, showWarningBar])
  const open = _react.useCallback.call(void 0, () => _store.history.push(`/forms/sent/${code}`), [code])
  const sendAgain = _react.useCallback.call(void 0, () => _sendFormRequests.requestSendForm.call(void 0, conversationKey, formKey), [conversationKey, formKey])

  if (!card) {
    return (
      _react2.default.createElement('div', { className: "forms-msgcard forms-msgcard--loading" , 'data-testid': "form-card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}
        , _react2.default.createElement('div', { className: "forms-msgcard--strip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}} )
        , _react2.default.createElement('div', { className: "forms-msgcard--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
          , _react2.default.createElement('div', { className: "forms-msgcard--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "Form")
          , _react2.default.createElement('div', { className: "forms-msgcard--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
            , _react2.default.createElement('button', { type: "button", className: "forms-link", onClick: open, __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "Open")
          )
        )
      )
    )
  }

  const detail = _forms.formCardDetail.call(void 0, card)
  return (
    _react2.default.createElement('div', { className: "forms-msgcard", 'data-testid': "form-card", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
      , _react2.default.createElement('button', { type: "button", className: "forms-msgcard--strip", onClick: open, 'aria-label': `Open ${card.FormName}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}
        ,  _optionalChain([card, 'access', _3 => _3.FirstPage, 'optionalAccess', _4 => _4.URL]) && _react2.default.createElement('img', { src: card.FirstPage.URL, alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}} ) 
        , _react2.default.createElement(_FormStatusChip2.default, { card: card, className: "forms-msgcard--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}} )
      )
      , _react2.default.createElement('div', { className: "forms-msgcard--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
        , _react2.default.createElement('div', { className: "forms-msgcard--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          , _react2.default.createElement('div', { className: "forms-msgcard--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}, _forms.formCardTitle.call(void 0, card))
          ,  detail && _react2.default.createElement('div', { className: "forms-msgcard--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}, detail) 
        )
        , _react2.default.createElement('div', { className: "forms-msgcard--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}
          ,  _forms.isOpenStatus.call(void 0, card.Status) && (
            _react2.default.createElement('button', { type: "button", className: "forms-link", onClick: copyLink, __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}, "content_copy"), "Copy link"
            )
          )
          , _react2.default.createElement('button', { type: "button", className: "forms-link", onClick: open, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, "visibility"), "Open"
          )
          ,  card.FormKey && (
            _react2.default.createElement('button', { type: "button", className: "forms-link", onClick: sendAgain, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, "refresh"), "Send again"
            )
          )
        )
      )
    )
  )
}

exports. default = FormCard
